import { render, staticRenderFns } from "./dynamic-panel-self.vue?vue&type=template&id=4b347b86&scoped=true"
import script from "./dynamic-panel-self.vue?vue&type=script&lang=js"
export * from "./dynamic-panel-self.vue?vue&type=script&lang=js"
import style0 from "./dynamic-panel-self.vue?vue&type=style&index=0&id=4b347b86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b347b86",
  null
  
)

export default component.exports